import React from 'react';
import Typography from '@mui/material/Typography';
import '@/styles/devices.scss';

interface FieldLabelProps {
  label: string;
  required?: boolean;
}

const FieldLabel: React.FC<FieldLabelProps> = ({ label, required = false }) => {
  return (
    <Typography className="field-label">
      {label}
      {required && <span className="required-mark">*</span>}
    </Typography>
  );
};

export default FieldLabel;
